import React from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { Link } from "react-router-dom";
import LocalizedStrings from 'react-localization';
import localization from '../../localization';
import toast from 'react-hot-toast';
import apiPath from "../../constants/apiPath";
import Http from "../../services/Http";
import { internalIpV4 } from '../../services/getIp';
import { userLogin } from "../../actions/index";
import { connect } from "react-redux";

let strings = new LocalizedStrings(localization);

// Google OAuth Web client ID (Google Identity Services). Override via .env if set.
const GOOGLE_CLIENT_ID =
    process.env.REACT_APP_GOOGLE_CLIENT_ID ||
    "550661215035-au3lu5j6rmp78b0si34bcaa3s2g9aave.apps.googleusercontent.com";

const mapStateToProps = state => {
    return { user: state.user };
};
const mapDispatchToProps = dispatch => {
    return {
        userLogin: user => dispatch(userLogin(user))
    };
};

const GoogleButton = (Props) => {
    const postSocialLogin = async (profile) => {
        let path = apiPath.sociallogin;
        var data = new FormData();
        data.append('email', profile.email || '');
        data.append('mobile', profile.email || '');
        data.append('social_id', (profile.sub || '').toString());
        data.append('social_type', 'Google');
        data.append('device_token', await internalIpV4());
        data.append('device_type', 'Web');
        data.append('name', profile.name || '');
        data.append('preferred_country', (Props.user && Props.user.details && Props.user.details.preferred_country) || '');
        data.append('preferred_language', (Props.user && Props.user.details && Props.user.details.preferred_language) || '');

        let result = await Http(path, { method: 'POST', data });
        if (result.status === 200) {
            if (result.data.status) {
                Props.userLogin(result.data.data);
                window.location.reload();
            } else {
                toast.error(result.data.message);
            }
        } else if (result.statusText != null) {
            toast.error(result?.data?.message || result.statusText);
        }
    };

    // Google Identity Services implicit flow -> access_token -> userinfo (email/name/sub)
    const login = useGoogleLogin({
        scope: 'openid email profile',
        onSuccess: async (tokenResponse) => {
            try {
                const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
                    headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
                });
                const profile = await res.json();
                if (!profile || !profile.email) {
                    toast.error("Social login failed");
                    return;
                }
                await postSocialLogin(profile);
            } catch (e) {
                toast.error("Social login failed");
            }
        },
        onError: () => toast.error("Social login failed"),
    });

    // Custom button matching the site's primary button (same look as "Continue with phone")
    return (
        <Link
            to="#"
            className="btn btn_primary"
            onClick={(e) => { e.preventDefault(); login(); }}
        >
            {strings.continue_with_google}
        </Link>
    );
};

const GoogleLogin = (Props) => {
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <GoogleButton {...Props} />
        </GoogleOAuthProvider>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(GoogleLogin);
